"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsiveContext = exports.ResponsiveContextProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var breakpoints_1 = require("./constants/breakpoints");
var defaultResponsiveContext = {
    breakpoints: {
        xs: breakpoints_1.SCREEN_BREAKPOINT_XS,
        sm: breakpoints_1.SCREEN_BREAKPOINT_SM,
        md: breakpoints_1.SCREEN_BREAKPOINT_MD,
        lg: breakpoints_1.SCREEN_BREAKPOINT_LG,
        xl: breakpoints_1.SCREEN_BREAKPOINT_XL,
        xxl: breakpoints_1.SCREEN_BREAKPOINT_XXL,
    },
};
var responsiveContext = react_1.default.createContext(defaultResponsiveContext);
responsiveContext.displayName = "ResponsiveContext";
/**
 * @internal
 */
exports.ResponsiveContextProvider = responsiveContext.Provider;
/**
 * Hook to consume responsive context.
 *
 * @internal
 */
exports.useResponsiveContext = function () { return react_1.useContext(responsiveContext); };
//# sourceMappingURL=ResponsiveContext.js.map